import type { RouterState } from './_state.type';

/** Router State. */
export const routerState: RouterState = {
  router: {
    reloadDocument: false,
  },
};
